// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1H23W","select":"Header_select__1kHxd","clinic":"Header_clinic__3anUB"};